import { Platform } from '@angular/cdk/platform';
import { Component, Input, inject } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { CarouselScrollComponent } from '../../../shared/components/carousel-scroll/carousel-scroll.component';
import { MatCard, MatCardContent } from '@angular/material/card';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-events-map-carousel',
  templateUrl: './events-map-carousel.component.html',
  styleUrls: ['./events-map-carousel.component.scss'],
  standalone: true,
  imports: [
    TranslocoModule,
    CarouselScrollComponent,
    MatCard,
    MatCardContent,
    DatePipe,
  ],
})
export class EventsMapCarouselComponent {
  private platform = inject(Platform);

  @Input() eventsArray: Array<{
    properties: {
      dateEnd?: Date,
      dateStart: Date,
      imgUrl: string,
      name: string,
      organizerName: string,
      url: string,
      oid?: number,
      showTime?: boolean,
    }
  }>;
  @Input() selectedEvent: number[];

  public itemSize = '200';
  private isBrowser = false;

  constructor() {
    this.isBrowser = this.platform.isBrowser;
    if (this.isBrowser) {
      const mediaQuery = window.matchMedia('(min-width: 576px)');
      if (mediaQuery.matches) {
        this.itemSize = '300';
      }
    }
  }

}
